var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-space-y-2 tw-py-2 sm:tw-space-y-4 sm:tw-py-4"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }